import { useEffect, useRef } from 'react';

// Runs fn every `ms` while the tab is visible; refreshes at once when the tab comes back.
export const useVisiblePolling = (fn, ms, enabled = true) => {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled) return undefined;
    let t = null;
    const start = () => { if (!t) t = setInterval(() => ref.current(), ms); };
    const stop = () => { clearInterval(t); t = null; };
    const onVis = () => {
      if (document.hidden) stop();
      else { ref.current(); start(); }
    };
    if (!document.hidden) start();
    document.addEventListener('visibilitychange', onVis);
    return () => { stop(); document.removeEventListener('visibilitychange', onVis); };
  }, [ms, enabled]);
};
